export default "__VITE_ASSET__CJOF6CIT__"